<template>
  <div>
    <!-- 输入搜索 -->
    <div class="searchboxClass">
        <header-and-search :searchArticle="searchArticle"></header-and-search>
    </div>
    <!-- 中间搜索 -->
    <div class="classificationClass">
      <div class="main_tab">
        <div @click='change(-1)' :class='currentIndex==-1?"allBtnClass_active":"allBtnClass"'>
          总库
        </div>
      </div>
      <div class="tab" id="tab">
        <ul>
          <div :key='item.id' v-for='(item,index) in list'>
            <li @click='change(index)' :class='currentIndex==index?"active":"no_active"' >
              <div class="class_parent_class">
                <div>
                 {{item.title}}
                </div>
                <div :class='item.classList.length>0?"class_child_div2":""'>
                  <div class="class_child_class2"  @click='selectItem(index2)' :key='item2.id' v-for='(item2,index2) in item.classList'>
                      {{item2.name}}
                  </div>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
    <!-- 搜索内容以及侧边栏分类 -->
    <div v-show="!searchFlag" class="emptyblock">
    </div>
    <div v-show="searchFlag" class="resultClass">
        <div class="resultLeftClassBlock">
            <div v-for="(item,index) in leftClassList" :key="item.id" class="item">
                <div @click="extendClass(index)" class="CollapseClass">&nbsp;&nbsp;{{item.name}} <i style="margin-right:5px" :class='item.boxshow == true?"el-icon-arrow-up":"el-icon-arrow-down"'></i></div>
                <!-- <button @click="boxshow = !boxshow">点击展开/关闭</button> -->
                <!--这里的name 和 css 类名第一个字段要一样-->
                <transition name="draw">
                    <div class="box" v-show="item.boxshow">
                        <div v-for="(item2) in item.classItemList" :key="item2.id">
                            <div class="classItemClass">
                                <el-checkbox v-model="checked" style="margin:0 6px"></el-checkbox>{{item2.name}}<div>({{item2.num}})</div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="resultTableClass">
            <search-result></search-result>
        </div>
    </div>
    <!-- 最下面关于我们 -->
    <div class="bottom_class">
        <div class="bottom_left_class">
            <div class="bottom_left_single_block_class">
                <div class="bottom_left_single_block_title_class">
                    公司简介
                </div>
                <div class="bottom_left_single_block_link_class">
                    愿景
                </div>
                <div class="bottom_left_single_block_link_class">
                    使命
                </div>
                <div class="bottom_left_single_block_link_class">
                    核心价值
                </div>
                <div class="bottom_left_single_block_link_class">
                    公司介绍
                </div>
            </div>
            <div class="bottom_left_single_block_class"> 
                <div class="bottom_left_single_block_title_class" style="width: 150px;">
                    特色服务
                </div>
                <div class="bottom_left_single_block_link_class" style="width: 150px;">
                    浮式智能环境监测
                </div>
                <div class="bottom_left_single_block_link_class" style="width: 150px;">
                    隐患排查治理平台
                </div>
                <div class="bottom_left_single_block_link_class" style="width: 150px;">
                    水温控系统
                </div>
                <div class="bottom_left_single_block_link_class" style="width: 150px;">
                    测温监控设备
                </div>
            </div>
            <div class="bottom_left_single_block_class">
                <div class="bottom_left_single_block_title_class">
                    关于我们
                </div>
                <div class="bottom_left_single_block_link_class">
                    公司业务
                </div>
                <div class="bottom_left_single_block_link_class">
                    诚募英才
                </div>
                <div class="bottom_left_single_block_link_class">
                    联系我们
                </div>
                <div class="bottom_left_single_block_link_class">
                    公司地址
                </div>
            </div>
            <div class="bottom_left_single_block_class">
                <div class="bottom_left_single_block_title_class">
                    客户咨询
                </div>
                <div class="bottom_left_single_block_link_class" style="width:200px">
                    服务热线：027-83900608
                </div>
                <div class="bottom_left_single_block_link_class" style="width:200px">
                    邮件咨询：info@tscon.cn
                </div>
                <div class="bottom_left_single_block_link_class">
                </div>
                <div class="bottom_left_single_block_link_class">
                </div>
            </div>
        </div>
        <div class="bottom_right_class">
            <div class="logo_text_class"><div class="weibo_class"></div><div>新浪微博客服</div></div>
            <div class="logo_text_class"><div class="weixin_class"></div><div style="margin-left:60px">官方微博</div></div>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderAndSearch from '../components/HeaderAndSearch.vue'
import SearchResult from '../components/result.vue'
export default {
    components: { HeaderAndSearch,SearchResult },
    data(){
    return{
      currentIndex:-1,
      list:[{
          id:1,
          title:'学术期刊',
          classList:[{
            id:0,
            name:"博士"
          },{
            id:1,
            name:"硕士"
          },
          ]
      },{
          id:2,
          title:'学位论文',
          classList:[]
      },{
          id:3,
          title:'会议',
          classList:[]
      },{
          id:4,
          title:'报纸',
          classList:[]
      },{
          id:5,
          title:'年鉴',
          classList:[]
      },{
          id:6,
          title:'图书',
          classList:[]
      },{
          id:7,
          title:'专利',
          classList:[]
      },{
          id:8,
          title:'标准',
          classList:[]
      },{
          id:9,
          title:'成果',
          classList:[]
      }],

      leftClassList:[{
          id:1,
          name:'主题',
          boxshow:false,
          classItemList:[{
                id:1,
                name:"教学中的应用",
                num:124
            },{
                id:2,
                name:"存在的问题及对策",
                num:150
            }
            ],
      },{
          id:2,
          name:'发表年度',
          boxshow:false,
          classItemList:[{
                id:1,
                name:"2021",
                num:10
            },{
                id:2,
                name:"2020",
                num:260
            }
        ]
      },{
          id:3,
          name:'文献来源',
          boxshow:false,
          classItemList:[]
      },{
          id:4,
          name:'学科',
          boxshow:false,
          classItemList:[]
      },{
          id:5,
          name:'作者',
          boxshow:false,
          classItemList:[]
      },{
          id:6,
          name:'机构',
          boxshow:false,
          classItemList:[]
      },{
          id:7,
          name:'基金',
          boxshow:false,
          classItemList:[]
      },{
          id:8,
          name:'文献来源',
          boxshow:false,
          classItemList:[]
      },
      ],
      boxshow:false,
      tabPosition: 'top',
      checked:true,
      searchList: ["土木工程","土木框架","土木工程地下","土木工程分类","土木英文文献","土木力学","土木工程论文","土木工程施工","土木工程专业","土木外文期刊","土木工程本科","土木框架结构","土木工程智能","土木工程认识"],
      src: "../assets/bg.jpg",
      searchFlag:false
    }
  },
  methods:{
      change:function(index){
        this.currentIndex=index;
      },
      extendClass(index){
        this.leftClassList[index].boxshow = !this.leftClassList[index].boxshow;
      },
      searchArticle(flag){
          this.searchFlag = flag;
      }
    }
}
</script>
<style scoped>
.searchboxClass{
  height: 543.5px;
  /* height: 58vh; */
}
.emptyblock{
    height:188px;
    /* height: 20vh; */
}
.classificationClass{
  /* height: 10vh; */
  height: 93.7px;
  display: flex;
  justify-content: center;
  background: url('../assets/banner.jpg') top center #0f5de5;
}
.resultClass{
  /* height:150vh; */
  height:1150px;
  display: flex;
  justify-content: center;
}
.resultLeftClassBlock{
    /* height: 80vh; */
    height: 749.6px;
    width: 12vw;
    margin-left: 6.8vw;
}
.resultTableClass{
    /* width: 50vw; */
    width: 960px;
}
.main_tab{
  width: 300px;
  height: 250px;
  margin-top:1.5vh;
  cursor: pointer;
}
.allBtnClass{
  margin:0 auto;
  height: 80px;
  width: 160px;
  line-height: 80px;
  font-size: 18px;
  color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.allBtnClass_active{
  margin:0 auto;
  height: 80px;
  width: 160px;
  line-height: 80px;
  font-size: 18px;
  background-color: #fff;
  color: #2878EB;
  font-weight: bold;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.tab {
    width: 900px;
    height: 250px;
    margin-top: 1.5vh;
}
ul {
    margin: 0;
    padding: 0;
    height: 50px;
}
li {
    cursor: pointer;
    box-sizing: border-box;
    height: 80px;
    width: 100px;
    list-style: none;
    text-align: center;
    line-height: 80px;
    float: left;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: #fff;
}
.active {
    background-color: #fff;
    color: #2878EB;
    font-weight: bold;
}
.no_active:hover{
  background-color: #fff;
  color: #2878EB;
  font-weight: bold;
}

.img {
    display: none;
    height: 250px;
    width: 400px;
}
.img img {
    height: 100%;
    width: 100%;
}
.current {
    display: block;
}
.class_child_class2{
  height: 30px;
  line-height: 30px;
  font-weight: 100;
  color:#666;
  font-size: 12px;
}
.class_child_class2:hover{
  color: #2878EB;
}
.class_child_div2{
  border:1px solid #5B9BD5;
  display: none;
  position:relative;
  background-color: #fff;
}
.class_child_div_none2{
  display: none;
}
.class_parent_class:hover .class_child_div2{ display: block;z-index: 999; }
.CollapseClass{
    cursor: pointer;
    margin-top:5px;
    width:90%;
    height: 30px;
    text-align: left;
    background-color: #E3ECFD;
    box-shadow: 1px 1px 1px 1px #cccccc;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    font-weight: bold;
    line-height: 32px;
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.box{
    width:90%;
    height:80px;
    background-color:#fff;
    box-shadow: 1px 1px 1px 1px #cccccc;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
}
.draw-enter-active, .draw-leave-active {
    transition: all 0 ease;
}
.draw-enter, .draw-leave-to {
    height: 0;
}
.classItemClass{
    text-align: left;
    font-size: 14px;
    display: flex;
}
.bottom_class{
    /* height: 20vh; */
    height: 187.5px;
    display: flex;
    justify-content: center;
    background: url('../assets/bg.jpg');
}
.iconfont{
    font-size: 40px;
}
.bottom_left_class{
    width:50vw;
    display: flex;
}
.bottom_right_class{
    margin:25px 0;
    width:15vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
.bottom_left_single_block_class{
    flex:1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.bottom_left_single_block_title_class{
    font-weight: bold;
    font-size: 15px;
    height: 30px;
    width: 100px;
    text-align: left;
}
.bottom_left_single_block_link_class{
    cursor: pointer;
    color: #333;
    font-size: 14px;
    width: 100px;
    text-align: left;
    height: 22px;
}
.bottom_left_single_block_link_class:hover{
    color: #5B9BD5;
}
.weixin_class{
    cursor: pointer;
    height: 40px;
    width: 40px;
    margin-left:60px;
    background-color: #2B82FF;
    border-radius: 50%;
    background-image: url('../assets/logo_wx.png');
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom:10px;
}
.weibo_class{
    cursor: pointer;
    background-color: #2B82FF;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    background-image: url('../assets/logo_xl.png');
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom:10px;
}
.logo_text_class{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color:#333;

}
</style>
